import { getJobProgramCompanies } from 'src/components/JobForm/utils';
import { ServiceTypes } from 'src/utils/data/types';
import { toDDMMMYY } from 'src/utils/format/date';

const getServicesText = (jobServices = []) => jobServices
  .filter(service => service.service.currentVersion.serviceType.type !== ServiceTypes.HIDDEN)
  .map(({ service }, index) => {

  const jobServicesCount = jobServices.filter(serviceItem => serviceItem.service.currentVersion.serviceType.type !== ServiceTypes.HIDDEN).length;
  
  return index === jobServicesCount - 1 ?
    service.currentVersion.name :
    `${service.currentVersion.name}, `;
}).join('').replaceAll('/', '-');

const getProgramsText = (programCompanies = []) => programCompanies.map(({ company }, index) => {
  return index === programCompanies.length - 1 ?
    company.currentVersion.name :
    `${company.currentVersion.name}, `;
}).join('').replaceAll('/', '-');

export const getSelectionList = (jobs = [], companyTypes) => {
  return Promise.all(jobs.map(async ({ id, reportNumber, jobServices, auditStartAt, jobCompanies }) => {

    const servicesText = getServicesText(jobServices);

    const programCompanies = getJobProgramCompanies(jobCompanies, companyTypes);
    const programsText = getProgramsText(programCompanies);

    return {
      id,
      displayText: `${reportNumber} / ${servicesText} / ${programsText} / ${toDDMMMYY(auditStartAt)}`,
    };
  }));
};
